import { AlertTitle as MuiAlertTitle } from '@mui/material';
import { alertTitleClasses, AlertTitleProps } from '@mui/material/AlertTitle';
import { styled } from '@mui/material/styles';

import { tokens } from '../../theme/styles/themeMui';

export type { AlertTitleProps };

export const AlertTitle: React.ComponentType<AlertTitleProps> = styled(
  MuiAlertTitle,
)<AlertTitleProps>(() => ({
  [`&.${alertTitleClasses.root}`]: {
    marginTop: 0,
    marginBottom: '8px',
    ...tokens.typography.bodyPrimary,
  },
}));
